import styled from 'styled-components';

export const StyledButton = styled.div`
  .btn {
    border-radius: 4px;
    background-color: ${props => (props.background ? props.background : 'transparent')};
	border: 1px solid ${props => (props.background ? props.background : '#707070')};	
	padding: ${props => (props.padding ? props.padding : '5px 15px')};	
	color: ${props => (props.color ? props.color : '#707070')};
	outline: 0;
	
	&:hover {
	  background-color: ${props => (props.backgroundHover ? props.backgroundHover : '#707070')};
	  color: ${props => (props.background ? props.background : '#FFFFFF')};
	}
  }
`;
